import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { deleteComment } from "../../../redux/actions/comments.actions";
import { useSearchParams } from "react-router-dom";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";
import { clearError } from "../../../redux/reducers/comments.reducer";

const DeleteCommentModal: React.FC<ModalProps> = ({open, setOpen,object}) => {
  const comment = object;

  const searchParams = useSearchParams()[0];

  const handleClose = () => {
      handleReset();
      setOpen(false);
    };

    const handleReset = () => {
      dispatch(clearError());
      setSubmitted(false);
    };

    const dispatch = useDispatch<AppDispatch>();
    const { accessToken } = useSelector((state: RootState) => state.user);
    const { error, loading } = useSelector((state: RootState) => state.comments);

    const [submitted, setSubmitted] = useState(false);

    const handleDelete = async (e: React.FormEvent) => {
      e.preventDefault();
      setSubmitted(true);
      await dispatch(deleteComment({id: comment?.id, spa_id:comment?.spa_id,params: searchParams.toString()}));
    };

  const step = !submitted ? "confirm" : loading && !error ? "deleting" : error ? "error" : "success";

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="sm"
      busy={step === "deleting"}
      tone={step === "confirm" ? "warning" : step === "error" ? "error" : step === "success" ? "success" : undefined}
      title={
        step === "confirm" ? "Delete comment?"
        : step === "deleting" ? "Deleting…"
        : step === "error" ? "An error occurred"
        : "Comment deleted"
      }
      subtitle={step === "confirm" && comment?.title ? comment.title : undefined}
      actions={
        step === "confirm" ?
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleDelete} disabled={!accessToken}>Delete</button>
        </>
        : step === "error" ?
        <>
          <button className="btn" onClick={handleClose}>Close</button>
          <button className="btn btn-primary" onClick={handleReset}>Try again</button>
        </>
        : step === "success" ?
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
        : undefined
      }
    >
      {step === "confirm" ?
        <p>This action cannot be undone.</p>
        : step === "deleting" ?
        <ModalLoading/>
        : step === "error" ?
        <p>{error}</p>
        :
        <p>Comment successfully deleted.</p>
      }
    </ModalShell>
  );
};

export default DeleteCommentModal;
